import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isError: null,
  isRobotModal: false,
  isRobot: false,
  requestConfig: {},
  otpErrorModal: false,
  otpModalOpen: false,
  currentOS: 0,
  acceptTermsModal: false,
  recognitionModal: false,
  recognitionLoading: false,
  theme: 'light',
};

const viewSlicer = createSlice({
  name: 'view',
  initialState,
  reducers: {
    setErrorMessage(state, action) {
      state.isError = action.payload;
    },
    setRobotModal(state, action) {
      state.isRobotModal = action.payload;
    },
    setRobot(state, action) {
      state.isRobot = action.payload;
    },
    setRequestConfig(state, action) {
      state.requestConfig = action.payload;
    },
    openOtpErrorModal: (state) => {
      state.otpErrorModal = true;
    },
    closeOtpErrorModal: (state) => {
      state.otpErrorModal = false;
    },
    handleCloseOtpModal: (state) => {
      state.otpModalOpen = false;
    },
    handleOpenOtpModal: (state) => {
      state.otpModalOpen = true;
    },
    setCurrentOS(state, action) {
      state.currentOS = action.payload;
    },
    setTheme(state, action) {
      state.theme = action.payload;
    },
    openAcceptTermsModal: (state) => {
      state.acceptTermsModal = true;
    },
    closeAcceptTermsModal: (state) => {
      state.acceptTermsModal = false;
    },
    openRecognitionInfoModal: (state) => {
      state.recognitionInfoModal = true;
    },
    closeRecognitionInfoModal: (state) => {
      state.recognitionInfoModal = false;
    },
    openRecognitionModal: (state) => {
      state.recognitionModal = true;
    },
    closeRecognitionModal: (state) => {
      state.recognitionModal = false;
    },
    openRecognitionLoadingModal: (state) => {
      state.recognitionLoading = true;
    },
    closeRecognitionLoadingModal: (state) => {
      state.recognitionLoading = false;
    },
  },
});

export const { actions } = viewSlicer;

export default viewSlicer.reducer;
